// TODO: 추후에 BE API가 나오면 응답값으로 대체
export const FAQ_CATEGORIES = {
  FREQUENTLY_ASKED: '자주 묻는 질문',
  GENERAL: '일반',
  CUSTOMER_SERVICE: '고객센터',
  REWARD: '리워드',
  SUBSCRIPTION: '구독형',
  APP_INSTALL_EXECUTION: '앱 설치 / 실행',
  PURCHASE: '구매형'
} as const

export const FAQ_UNAPPLIED_PUBLISHERS = ['NAVER_WEBTOON', 'SERIES', 'TOSS', 'MYBOX', 'BAEMIN', 'SOCDOC'] as const

export type FaqCategoryKey = keyof typeof FAQ_CATEGORIES
export type FaqCategoryValue = (typeof FAQ_CATEGORIES)[FaqCategoryKey]
